<template>
    <div class="upload-progress">
      <template v-if="preparing">
        <div class="preparation-message">
          <div class="preparation-spinner"></div>
          <span>Preparing for upload...</span>
        </div>
      </template>
      <template v-else>
        <div class="progress-bar" :style="{ width: `${progress}%` }"></div>
        <div class="progress-text">{{ progressText }}</div>
      </template>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      progress: {
        type: Number,
        required: true
      },
      fileName: {
        type: String,
        required: true
      },
      preparing: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      progressText() {
        return `${this.fileName}: ${this.progress.toFixed(2)}%`;
      }
    }
  }
  </script>
  
  <style scoped>
  .upload-progress {
    width: 100%;
    height: 20px;
    background-color: #f0f0f0;
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 10px;
    position: relative;
    box-shadow: inset 0 1px 3px rgba(0,0,0,0.1);
  }
  
  .progress-bar {
    height: 100%;
    background-color: #2EB85C;
    transition: width 0.3s ease-in-out;
  }
  
  .progress-text {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    text-align: center;
    line-height: 20px;
    color: #000;
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0 10px;
  }
  
  .preparation-message {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background-color: #f8f9fa;
    font-size: 12px;
    color: #666;
  }
  
  .preparation-spinner {
    width: 12px;
    height: 12px;
    border: 2px solid #2EB85C;
    border-top-color: transparent;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  </style>
  
  